const trustedParentHostnames = ["localhost", "app.beta.custouch.com", "app.cloud.custouch.com"]

export function isTrustedParentIframe() {
    if (window.self === window.top || !document.referrer) return false

    try {
        return trustedParentHostnames.includes(new URL(document.referrer).hostname)
    } catch (error) {
        return false
    }
}
